module.exports = __webpack_public_path__ + "static/scale-model-of-knoxville-tennessee-58a6dbb96355fc6a13d7849fd3786160.png";